import { Layout } from "@/components/Layout";
import { Link } from "react-router-dom";

function Page({ title, children }) {
  return (
    <Layout>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-16">
        <h1 className="font-display font-extrabold uppercase tracking-wide text-4xl text-[#0f172a]">{title}</h1>
        <div className="prose prose-slate mt-6 text-slate-600 space-y-4 leading-relaxed">{children}</div>
      </div>
    </Layout>
  );
}

export function About() {
  return (
    <Page title="About YourRaceFinder">
      <div data-testid="about-content" className="space-y-6">
        <p>YourRaceFinder makes it easier to discover races across Malaysia &amp; Singapore. From road running and trail running to cycling, triathlon, duathlon and fitness racing, we bring races together in one place so athletes can quickly find upcoming events that match their sport, location and distance.</p>

        <h2 className="font-display font-bold uppercase tracking-wide text-slate-800 text-lg">Find Your Next Race</h2>
        <p>Whether you're looking for your next 5K, marathon, trail race, cycling event or triathlon, YourRaceFinder helps you discover what's coming up across Malaysia and Singapore. Browse race listings, explore event details and go directly to the organizer's registration page when you're ready to enter.</p>

        <h2 className="font-display font-bold uppercase tracking-wide text-slate-800 text-lg">For Race Organizers</h2>
        <p>YourRaceFinder gives race organizers a dedicated place to showcase their events and reach athletes who are actively looking for their next race. Organizers can present their race with key event information, distances, categories, race dates, medal and merchandise images, and a direct registration link.</p>
        <p>YourRaceFinder is a race discovery platform. Registration and payment for races are handled directly by the race organizer.</p>
      </div>
      <Link to="/races" className="inline-block bg-[#0a1420] text-white font-bold px-6 py-3 rounded-lg no-underline mt-2">Find a Race</Link>
    </Page>
  );
}
export default About;
